import React from 'react';
import { Router as ReactRouter, Route, Switch, Redirect } from 'react-router-dom';
import history from './history';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import CafeteriaHomePage from './pages/CafeteriaHomePage';
import ProductAnalyticsPage from './pages/ProductAnalyticsPage';
import Pulse from './pages/Pulse';
import CustomerAnalytics from './pages/CustomerAnalytics';
import DayAnalytics from './pages/DayAnalytics';
import CafeteriaAnalytics from './pages/CafeteriaAnalytics';
import SalonAnalytics from './pages/SalonAnalytics';
import HealthAnalytics from './pages/HealthAnalytics';
import InventoryAnalytics from './pages/InventoryAnalytics';
import GeneralStatistics from './pages/GeneralStatistics';
import ProductsPage from './pages/ProductsPage';
import UsersPage from './pages/UsersPage';
import ProfilePage from './pages/ProfilePage';
import TicketPage from './pages/TicketPage';
import AddProductPage from './pages/AddProductPage';
import AdminsPage from './pages/AdminsPage';
import EditProductPage from './pages/EditProductPage';
import UsedGamesPage from './pages/UsedGamesPage';
import AddUsedGamePage from './pages/AddUsedGamePage';
import EditUsedGamePage from './pages/EditUsedGamePage';
import UsedGamesAnalytics from './pages/UsedGamesAnalytics';
import CafeteriaMenuPage from './pages/CafeteriaMenuPage';
import AddCafeteriaMenuPage from './pages/AddCafeteriaMenuPage';
import EditCafeteriaMenuPage from './pages/EditCafeteriaMenuPage';
import CafeteriaPosPage from './pages/CafeteriaPosPage';
import CafeteriaOrdersPage from './pages/CafeteriaOrdersPage';
import CafeteriaInsumosPage from './pages/CafeteriaInsumosPage';
import AddCafeteriaInsumoPage from './pages/AddCafeteriaInsumoPage';
import EditCafeteriaInsumoPage from './pages/EditCafeteriaInsumoPage';
import CafeteriaReposicionesPage from './pages/CafeteriaReposicionesPage';
import CafeteriaImpresoraPage from './pages/CafeteriaImpresoraPage';
import UserCreditPage from './pages/UserCreditPage';
import StoreCreditsPage from './pages/StoreCreditsPage';
import GiftCardsPage from './pages/GiftCardsPage';
import AddAdminPage from './pages/AddAdminPage';
import CredentialsPage from './pages/CredentialsPage';
import PurchasePage from './pages/PurchasePage';
import AddPurchasePage from './pages/AddPurchasePage';
import PriceCheckPage from './pages/PriceCheckPage';
import PresupuestosPage from './pages/PresupuestosPage';
import AddDiscountCode from './pages/AddDiscountCodePage';
import EditDiscountCodePage from './pages/EditDiscountCodePage';
import ShippingPage from './pages/ShippingPage';
import ProviderPage from './pages/ProviderPage';
import AddUserPage from './pages/AddUserPage';
import RestockingPage from './pages/RestockingPage';
import ProviderInvoicesPage from './pages/ProviderInvoicesPage';
import MovementsPage from './pages/MovementsPage';
import CajaPage from './pages/CajaPage';
import CashControlPage from './pages/CashControlPage';
import DiscountCodesPage from './pages/DiscountCodesPage';
import RefreshTokenPage from './pages/RefreshTokenPage';
import AddRestockingPage from './pages/AddRestockingPage';
import AddInvoicePage from './pages/AddInvoicePage';
import InvoicesPage from './pages/InvoicesPage';
import ReceivedInvoicesPage from './pages/ReceivedInvoicesPage';
import LabelsPage from './pages/LabelsPage';
import AddLabelPage from './pages/AddLabelPage';
import EditLabelPage from './pages/EditLabelPage';
import LabelAssignPage from './pages/LabelAssignPage';
import SoldProductsPage from './pages/SoldProductsPage';
import ConfigurationPage from './pages/ConfigurationPage';
import StockMonitorPage from './pages/StockMonitorPage';
import PriceReviewPage from './pages/PriceReviewPage';
import CompetitorPricesPage from './pages/CompetitorPricesPage';
import ProviderOrdersPage from './pages/ProviderOrdersPage';
import StockTransfersPage from './pages/StockTransfersPage';
import MlIntegrationPage from './pages/MlIntegrationPage';
import ShelfRestockPage from './pages/ShelfRestockPage';
import StockCountPage from './pages/StockCountPage';
import StockCountAdminPage from './pages/StockCountAdminPage';
import StockHistoryPage from './pages/StockHistoryPage';
import CartsPage from './pages/CartsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import TournamentsPage from './pages/TournamentsPage';
import TournamentPage from './pages/TournamentPage';
import EventsPage from './pages/EventsPage';
import AddEventPage from './pages/AddEventPage';
import AddPrivateEventPage from './pages/AddPrivateEventPage';
import EditEventPage from './pages/EditEventPage';
import EventAdmissionsPage from './pages/EventAdmissionsPage';
import MembershipsPage from './pages/MembershipsPage';
import MembershipDetailPage from './pages/MembershipDetailPage';
import SeriesPage from './pages/SeriesPage';
import SeriesDetailPage from './pages/SeriesDetailPage';
import OpenTablesPage from './pages/OpenTablesPage';
import AddOpenTablePage from './pages/AddOpenTablePage';
import EditOpenTablePage from './pages/EditOpenTablePage';
import OpenTableSignupsPage from './pages/OpenTableSignupsPage';
import ReservationsPage from './pages/ReservationsPage';
import LudotecaPage from './pages/LudotecaPage';
import EmailTemplatesPage from './pages/EmailTemplatesPage';
import EditEmailTemplatePage from './pages/EditEmailTemplatePage';
import EmailLogPage from './pages/EmailLogPage';
import EmailLogDetailPage from './pages/EmailLogDetailPage';
import PortadaImagesPage from './pages/PortadaImagesPage';
import TvCarteleraPage from './pages/TvCarteleraPage';

import { PrimeReactProvider } from 'primereact/api';

// ENI-167: se fue `@firebase/storage` (las imágenes pasan ahora por el backend) y con él
// `@firebase/firestore`, que estaba importado por side-effect y no se usaba en ninguna pantalla.
// Queda analytics, que sí se inicializa abajo.
import firebase from '@firebase/app';
import '@firebase/analytics';

var config = process.env;

const firebaseConfig = {
  apiKey: config.REACT_APP_FIREBASE_API_KEY,
  authDomain: config.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: config.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: config.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: config.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: config.REACT_APP_FIREBASE_APP_ID,
  measurementId: config.REACT_APP_FIREBASE_MEASUREMENT_ID 
}
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const Router = () => {
  return (
    <PrimeReactProvider>
    <ReactRouter history={history}>
      <Switch>
        <Route exact path={"/"} component={LoginPage} />
        <Route exact path={"/home"} component={HomePage} />
        <Route exact path={"/cafeteriaHome"} component={CafeteriaHomePage} />
        <Route exact path={"/generalStatistics"} component={GeneralStatistics} />
        <Route exact path={"/inventoryAnalytics"} component={InventoryAnalytics} />
        <Route exact path={"/pulse"} component={Pulse} />
        <Route exact path={"/customerAnalytics"} component={CustomerAnalytics} />
        <Route exact path={"/dayAnalytics"} component={DayAnalytics} />
        <Route exact path={"/cafeteriaAnalytics"} component={CafeteriaAnalytics} />
        <Route exact path={"/salonAnalytics"} component={SalonAnalytics} />
        <Route exact path={"/healthAnalytics"} component={HealthAnalytics} />
        
        <Route exact path={"/credentials"} component={CredentialsPage} />

        <Route exact path={"/admin"} component={AdminsPage} />
        <Route exact path={"/addAdmin"} component={AddAdminPage} />

        <Route exact path={"/products"} component={ProductsPage} />
        <Route exact path={"/addProduct"} component={AddProductPage} />
        <Route exact path={"/editProduct"} component={EditProductPage} />

        <Route exact path={"/boxGames"} render={(props) => <ProductsPage {...props} forcedProductType={1} />} />
        <Route exact path={"/addBoxGame"} render={(props) => <AddProductPage {...props} forcedProductType={1} />} />
        <Route exact path={"/editBoxGame"} component={EditProductPage} />

        <Route exact path={"/accessories"} render={(props) => <ProductsPage {...props} forcedProductType={2} />} />
        <Route exact path={"/addAccessory"} render={(props) => <AddProductPage {...props} forcedProductType={2} />} />
        <Route exact path={"/editAccessory"} component={EditProductPage} />

        <Route exact path={"/usedGames"} component={UsedGamesPage} />
        <Route exact path={"/addUsedGame"} component={AddUsedGamePage} />
        <Route exact path={"/editUsedGame"} component={EditUsedGamePage} />
        <Route exact path={"/usedGamesAnalytics"} component={UsedGamesAnalytics} />

        <Route exact path={"/cafeteria"} component={CafeteriaPosPage} />
        <Route exact path={"/cafeteriaOrders"} component={CafeteriaOrdersPage} />
        <Route exact path={"/cafeteriaMenu"} component={CafeteriaMenuPage} />
        <Route exact path={"/addCafeteriaMenu"} component={AddCafeteriaMenuPage} />
        <Route exact path={"/editCafeteriaMenu"} component={EditCafeteriaMenuPage} />
        <Route exact path={"/cafeteriaInsumos"} component={CafeteriaInsumosPage} />
        <Route exact path={"/addCafeteriaInsumo"} component={AddCafeteriaInsumoPage} />
        <Route exact path={"/editCafeteriaInsumo"} component={EditCafeteriaInsumoPage} />
        <Route exact path={"/cafeteriaReposiciones"} component={CafeteriaReposicionesPage} />
        <Route exact path={"/cafeteriaImpresora"} component={CafeteriaImpresoraPage} />

        
        <Route exact path={"/invoices"} component={InvoicesPage} />
        <Route exact path={"/receivedInvoices"} component={ReceivedInvoicesPage} />
        <Route exact path={"/addInvoice"} component={AddInvoicePage} />

        <Route exact path={"/productAnalytics"} component={ProductAnalyticsPage} />        
        
        <Route exact path={"/providers"} component={ProviderPage} />
        <Route exact path={"/discountCodes"} component={DiscountCodesPage} />
        <Route exact path={"/emailTemplates"} component={EmailTemplatesPage} />
        <Route exact path={"/editEmailTemplate/:key"} component={EditEmailTemplatePage} />
        <Route exact path={"/emailLog"} component={EmailLogPage} />
        <Route exact path={"/emailLog/:id"} component={EmailLogDetailPage} />
        <Route exact path={"/users"} component={UsersPage} />
        <Route exact path={"/addUser"} component={AddUserPage} />
        <Route exact path={"/userCredit"} component={UserCreditPage} />
        <Route exact path={"/storeCredits"} component={StoreCreditsPage} />
        <Route exact path={"/giftCards"} component={GiftCardsPage} />
        <Route exact path={"/clientDetail"} component={ClientDetailPage} />
        <Route exact path={"/carts"} component={CartsPage} />
        <Route exact path={"/tickets"} component={TicketPage} />
        <Route exact path={"/profile"} component={ProfilePage} />
        <Route exact path={"/purchase"} component={PurchasePage} />
        <Route exact path={"/shipping"} component={ShippingPage} />
        <Route exact path={"/addPurchase"} component={AddPurchasePage} />
        <Route exact path={"/priceCheck"} component={PriceCheckPage} />
        <Route exact path={"/presupuestos"} component={PresupuestosPage} />
        <Route exact path={"/addDiscountCode"} component={AddDiscountCode} />
        <Route exact path={"/editDiscountCode"} component={EditDiscountCodePage} />
        <Route exact path={"/caja"} component={CajaPage} />
        <Route exact path={"/controlCaja"} component={CashControlPage} />
        <Route exact path={"/restocking"} component={RestockingPage} />
        <Route exact path={"/addRestocking"} component={AddRestockingPage} />
        <Route exact path={"/providerInvoices"} component={ProviderInvoicesPage} />
        <Route exact path={"/movements"} component={MovementsPage} />

        <Route exact path={"/labels"} component={LabelsPage} />
        <Route exact path={"/addLabel"} component={AddLabelPage} />
        <Route exact path={"/editLabel"} component={EditLabelPage} />
        <Route exact path={"/labelAssign"} component={LabelAssignPage} />


        <Route exact path={"/soldProducts"} component={SoldProductsPage} />
        <Route exact path={"/configurations"} component={ConfigurationPage} />

        <Route exact path={"/refreshTokenMP"} component={RefreshTokenPage} />
        <Route exact path={"/stockMonitor"} component={StockMonitorPage} />
        <Route exact path={"/priceReview"} component={PriceReviewPage} />
        <Route exact path={"/competitorPrices"} component={CompetitorPricesPage} />
        <Route exact path={"/providerOrders"} component={ProviderOrdersPage} />
        <Route exact path={"/stockTransfers"} component={StockTransfersPage} />
        <Route exact path={"/mlIntegration"} component={MlIntegrationPage} />
        {/* Alias de la ruta vieja: la pantalla se llamaba "Órdenes ML caídas" y puede estar
            en un favorito o en un link pegado en el chat del equipo. */}
        <Route exact path={"/failedMlOrders"} component={MlIntegrationPage} />
        <Route exact path={"/shelfRestock"} component={ShelfRestockPage} />
        <Route exact path={"/stockCount"} component={StockCountPage} />
        <Route exact path={"/stockCountAdmin"} component={StockCountAdminPage} />
        <Route exact path={"/stockHistory"} component={StockHistoryPage} />

        <Route exact path={"/events"} component={EventsPage} />
        <Route exact path={"/addEvent"} component={AddEventPage} />
        <Route exact path={"/addPrivateEvent"} component={AddPrivateEventPage} />
        <Route exact path={"/editEvent"} component={EditEventPage} />
        <Route exact path={"/eventAdmissions"} component={EventAdmissionsPage} />
        <Route exact path={"/memberships"} component={MembershipsPage} />
        <Route exact path={"/membershipDetail"} component={MembershipDetailPage} />

        {/* Series del club. El detalle va DESPUÉS del listado y con `exact`: sin eso,
            "/series/12" también matchearía "/series" y el <Switch> se quedaría con el
            listado. */}
        <Route exact path={"/series"} component={SeriesPage} />
        <Route exact path={"/series/:id"} component={SeriesDetailPage} />

        <Route exact path={"/openTables"} component={OpenTablesPage} />
        <Route exact path={"/addOpenTable"} component={AddOpenTablePage} />
        <Route exact path={"/editOpenTable/:id"} component={EditOpenTablePage} />
        <Route exact path={"/openTableSignups/:id"} component={OpenTableSignupsPage} />
                <Route exact path={"/tournaments"} component={TournamentsPage} />
                <Route exact path={"/tournament"} component={TournamentPage} />
        <Route exact path={"/reservations"} component={ReservationsPage} />
        <Route exact path={"/ludoteca"} component={LudotecaPage} />
        <Route exact path={"/portadaImages"} component={PortadaImagesPage} />
        <Route exact path={"/cartelera"} component={TvCarteleraPage} />
        {/* Sin esto una ruta desconocida renderizaba una pantalla EN BLANCO, sin forma de
            salir salvo escribir la URL a mano. Y no era hipotético: ~110 lugares hacen
            `window.location.href = localStorage.getItem('homePageURL')` al recibir un 1002,
            y esa clave sólo se escribe en el login — si falta, el browser navega literal a
            "/null". Cualquier ruta que no exista vuelve al login. */}
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </ReactRouter>
    
    </PrimeReactProvider>
  );
}


export default Router;
